const getYears = () => {
    const allYears = [];

    // from now to 2016
    const currentYear = new Date().getFullYear();
    const startYear = new Date("2016").getFullYear();

    for (let i = currentYear; i >= startYear; i--) {
        const year = String(i);

        allYears.push({
            id: year,
            title: year
        });
    }
    // ---

    // from 2015 now to 1980
    const customYears = [];
    let fromYear = 2015;
    let everyFixedYears = 5;

    let extraYearItem = {};

    for (let i = 2015; i >= 1980; i--) {
        if (fromYear === i && everyFixedYears === 0) {
            fromYear = i;
            everyFixedYears = 5;
            extraYearItem.id += `,${i}`;

            customYears.push(extraYearItem);

            extraYearItem = {};
        }

        if (!extraYearItem.title) {
            extraYearItem.title = `${fromYear - everyFixedYears}-${fromYear}`;
        }

        extraYearItem.id = extraYearItem.id
            ? (extraYearItem.id += `,${i}`)
            : (extraYearItem.id = `${i}`);

        fromYear -= 1;
        everyFixedYears -= 1;
    }

    allYears.push(...customYears);
    // ---

    // from 1920 to 1980
    for (let i = 1979; i >= 1920; i--) {
        if (extraYearItem.title) extraYearItem.title = "До 1980";

        extraYearItem.id = extraYearItem.id
            ? (extraYearItem.id += `,${i}`)
            : (extraYearItem.id = `${i}`);
    }

    allYears.push(extraYearItem);
    // ---

    return allYears;
};

export default getYears;
